import React from 'react'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import langUrl from '../utils/langUrl'

const RedirectRoute = ({ location }) => {
  return location.state?.pathname || location.pathname.length > 3 ? (
    <Redirect to={{ pathname: `/${langUrl}/users/login` }} />
  ) : (
    <Redirect to={{ pathname: `/${langUrl}` }} />
  )
}

export default RedirectRoute

RedirectRoute.propTypes = {
  location: PropTypes.any,
}
